// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1n1_c","title":"styles_title__3DIwJ"};